module.exports = __webpack_public_path__ + "img/slider-light-01.c64fcc19.png";